import React, { useEffect, useState } from 'react'
import StopeChart from './StopeChart';

export default function StopeStatistics() {  
  

  return (
    <div className="flex flex-col w-full h-full bg-gray-100 p-2 sm:p-4 overflow-y-auto">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-sm sm:text-lg font-semibold text-gray-800">{'PK UNDERGROUND STOPE STATISTICS'}</h2>
      </div>
      
      <StopeChart/> 
    </div>
  )
}







